import { AibleClientFactory } from "client/aible/factory";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as reportReducer from "containers/Report/ReportReducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as aiServiceReducer from "containers/AiService/reducer";
import { getUserID } from "containers/Login/reducer";
import { dislikeRatable, likeRatable } from "containers/Ratings/reducer";
const initialState = {};
const UPDATE_FIELD = "chatDetails/UPDATE_FIELD";
const UPDATE_FIELD_VALUE = "chatDetails/UPDATE_FIELD_VALUE";
const UPDATE_BASE = "chatDetails/UPDATE_BASE";
const RESET = "chatDetails/RESET";
const doUpdateBase = (state, action) => {
    return {
        ...state,
        ...action.data
    };
};
const doUpdateField = (state, action) => {
    return {
        ...state,
        [action.id]: action.data
    };
};
const doUpdateFieldValue = (state, action) => {
    return {
        ...state,
        [action.id]: {
            ...state[action.id],
            [action.key]: action.data
        }
    };
};
function ChatDetailsReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_BASE:
            return doUpdateBase(state, action);
        case UPDATE_FIELD:
            return doUpdateField(state, action);
        case UPDATE_FIELD_VALUE:
            return doUpdateFieldValue(state, action);
        case RESET:
            return initialState;
        default:
            return state;
    }
}
export default ChatDetailsReducer;
function getBase(state) {
    return state.chatDetails;
}
export function resetChatDetails() {
    return { type: RESET };
}
export function getAllChatMessageDetails(state) {
    return getBase(state);
}
export function getChatMessageDetails(state, id) {
    return id === undefined ? undefined : getBase(state)[id];
}
export function getChatMessageDetailsKeys(state) {
    return Object.keys(getBase(state) ?? {});
}
export function getChatMessageDetailsArray(state) {
    return Object.values(getBase(state) ?? {});
}
export function getChatMessageDetailById(id) {
    return (dispatch, getState) => {
        return getBase(getState())[id];
    };
}
export function getDetailIsLoaded(state, id) {
    const exists = getBase(state)[id];
    return !!exists;
}
export function getReportChatMessageDetails(state, nextId) {
    const details = getChatMessageDetailsArray(state);
    const report = reportReducer.getReport(state, nextId);
    const currNextId = nextReducer.getCurrentNextId(state);
    let currConversation = report?.metadata?.chatGPTConvo?.conversation;
    if (nextId === currNextId && currNextId === "new") {
        currConversation = chatGPTReducer.getConversation(state);
    }
    const conversation = currConversation ?? {};
    // Create an object that contains all the chat message detail Ids from the report
    // This is more accurate than just looking for the reportId in the chat message detail because that doesn't seem to always be there
    const chatDetailIds = {};
    for (const key in conversation) {
        const currMessage = conversation[key];
        const cDetailIds = currMessage?.ids;
        if (cDetailIds?.length) {
            cDetailIds.forEach((cId) => {
                chatDetailIds[cId] = true;
            });
        }
    }
    return details.filter((detail) => chatDetailIds[detail.id]);
}
export function getDetailsForReports(state, nextIdArray) {
    const reportsDetails = nextIdArray.flatMap((nId) => {
        const currDetails = getReportChatMessageDetails(state, nId);
        return currDetails.map((d) => {
            return {
                ...d,
                reportId: nId
            };
        });
    });
    return reportsDetails;
}
export function getReportLikedChatDetails(state, nextId) {
    const report = reportReducer.getReport(state, nextId);
    const currNextId = nextReducer.getCurrentNextId(state);
    let currConversation = report?.metadata?.chatGPTConvo?.conversation;
    if (nextId === currNextId && currNextId === "new") {
        currConversation = chatGPTReducer.getConversation(state);
    }
    const conversation = currConversation ?? {};
    // Create an object that contains all the chat message detail Ids from the report
    // This is more accurate than just looking for the reportId in the chat message detail because that doesn't seem to always be there
    const likedChatDetailsById = {};
    for (const key in conversation) {
        const currMessage = conversation[key];
        const cDetailIds = currMessage?.contentGenerationIds ?? [];
        const messageLiked = (currMessage?.feedback?.THUMBS_UP?.length ?? 0) > 0;
        for (const cId of cDetailIds) {
            const currDetails = getChatMessageDetails(state, cId);
            if (currDetails === undefined) {
                continue;
            }
            if (messageLiked) {
                likedChatDetailsById[cId] = currDetails;
                continue;
            }
            let detailLiked = currDetails.like_count > 0;
            if (detailLiked === false) {
                for (const cResult of currDetails.results) {
                    if (cResult.like_count > 0) {
                        detailLiked = true;
                        break;
                    }
                    if (cResult.data.output_feedback === undefined) {
                        break;
                    }
                    for (const cFeedback of cResult.data.output_feedback) {
                        if (detailLiked) {
                            break;
                        }
                        for (const feedbackItem of cFeedback.feedback_items) {
                            if (feedbackItem.score > 0) {
                                detailLiked = true;
                                break;
                            }
                        }
                    }
                }
            }
            if (detailLiked) {
                likedChatDetailsById[cId] = currDetails;
            }
        }
    }
    return Object.values(likedChatDetailsById);
}
export function getLikedDetailsForReports(state, nextIdArray) {
    const reportsDetails = nextIdArray.flatMap((nId) => {
        const currDetails = getReportLikedChatDetails(state, nId);
        return currDetails.map((d) => {
            return {
                ...d,
                reportId: nId
            };
        });
    });
    return reportsDetails;
}
export function getLikedResponsesFromSelectedReports(state, selectedReports, templateName) {
    // Lifted the logic for finding the responses for showing in the create training data flow's responses table (CreateTrainingDataModal > ResponsesDataTable) component
    // Only use liked details / skip rephrase_query tasks
    const likedDetails = getLikedDetailsForReports(state, selectedReports);
    const validDetails = likedDetails?.filter((detail) => detail.results);
    const reports = reportReducer.getReports(state);
    const aiServiceModels = aiServiceReducer.getModels(state);
    const responseData = validDetails
        .flatMap((chatDetail) => {
        const foundReport = reports?.find((report) => report?.id === chatDetail.reportId);
        const contentData = chatDetail.results
            .filter((r) => r.like_count > 0 || chatDetail.like_count > 0)
            .map((contentItem) => {
            const combinedQuery = contentItem.data.input.messages.map((message) => message.content).join("");
            const modelId = contentItem.data.input.generation_config.model_id;
            let modelString = contentItem.data.input.generation_config.model;
            if (modelId && !isNaN(modelId)) {
                modelString = Object.values(aiServiceModels).find((model) => model?.id === modelId)?.name ?? modelString;
            }
            const resultData = contentItem.data.input.messages.reduce((messageAcc, currentMsg) => {
                if (currentMsg.reference_data === undefined) {
                    return messageAcc;
                }
                for (const dataItem of currentMsg.reference_data) {
                    if (dataItem.type === "CORPUS") {
                        for (const document of dataItem.documents) {
                            const currentArtifactId = document.metadata.artifact_id;
                            if (currentArtifactId !== undefined) {
                                messageAcc.artifacts.add(currentArtifactId);
                            }
                        }
                    }
                    else if (dataItem.type === "DATASET_QUERY") {
                        messageAcc.datasets.add(dataItem.dataset_id);
                    }
                    else if ("charts" in dataItem) {
                        for (const chart of dataItem.charts) {
                            messageAcc.datasets.add(chart.dataset_id);
                        }
                    }
                }
                return messageAcc;
            }, {
                artifacts: new Set(),
                datasets: new Set()
            });
            const itemData = {
                projectName: chatDetail.reportId == "new"
                    ? (templateName ?? "Current Template")
                    : (foundReport?.name ?? "Missing Project Name"),
                query: combinedQuery,
                response: contentItem?.data?.output?.content,
                id: contentItem?.id,
                detailId: chatDetail?.id,
                modelId: modelString,
                resultData: {
                    artifacts: Array.from(resultData.artifacts),
                    datasets: Array.from(resultData.datasets)
                },
                taskName: contentItem?.task_name
            };
            return itemData;
        });
        return contentData;
    })
        .filter((d) => {
        return d.taskName !== "rephrase_query";
    });
    return responseData;
}
export function updateChatMessageDetails(id, details) {
    return { type: UPDATE_FIELD, id: id, data: details };
}
// Todo: split out the fetching part. The fetch queue is useful.
// Also, remove the helper. Not needed after splitting out the fetch
export function fetchReportChatMessageDetails(reportId) {
    return async (dispatch, getState) => {
        const report = reportReducer.getReport(getState(), reportId);
        const nextId = nextReducer.getCurrentNextId(getState());
        let currConversation = report?.metadata?.chatGPTConvo?.conversation;
        if (nextId === reportId && reportId === "new") {
            currConversation = chatGPTReducer.getConversation(getState());
        }
        const conversation = currConversation ?? {};
        const validMessages = Object.values(conversation).filter((message) => {
            return message?.contentGenerationIds?.length;
        });
        const CONCURRENT_REQUESTS = Math.min(validMessages.length || 0, 5);
        const fetchHelper = () => {
            if (validMessages?.length) {
                const cMessage = validMessages.pop();
                if (cMessage) {
                    return dispatch(fetchMessageChatMessageDetails(cMessage));
                }
            }
            return Promise.resolve();
        };
        while (validMessages.length > 0) {
            const fetchPromises = [];
            for (let i = 0; i < CONCURRENT_REQUESTS; i++) {
                const cFetch = fetchHelper();
                fetchPromises.push(cFetch);
            }
            await Promise.all(fetchPromises);
        }
        return Promise.resolve();
    };
}
// Given a chat message, will fetch the chat details for the message
// Will not fetch the details if they're already there.
export function fetchMessageChatMessageDetails(message) {
    return async (dispatch, getState) => {
        if (message?.contentGenerationIds?.length) {
            const cAccount = message.contentGenerationAccount ?? chatGPTReducer.getChatGPTAccountId(getState());
            const promises = message.contentGenerationIds.map((cId) => {
                const cDetails = getChatMessageDetails(getState(), cId);
                if (cDetails && cDetails?.status !== "RUNNING") {
                    return Promise.resolve(cDetails);
                }
                return dispatch(fetchChatMessageDetails(cId, cAccount)).catch((e) => console.log(e));
            });
            await Promise.all(promises);
        }
        return Promise.resolve();
    };
}
//Assumes the conversation has already been fetched
export function fetchAllChatMessageDetails() {
    return async (dispatch, getState) => {
        const reportsArr = reportReducer.getReportsArr(getState());
        for (const r of reportsArr) {
            if (r?.id) {
                try {
                    await dispatch(fetchReportChatMessageDetails(r.id));
                }
                catch (e) {
                    console.log(e);
                }
            }
        }
        return Promise.resolve();
    };
}
export function getOrFetchMessageDetails(id) {
    return (dispatch, getState) => {
        const execution = getChatMessageDetails(getState(), id);
        if (execution !== undefined) {
            return Promise.resolve(execution);
        }
        return dispatch(fetchChatMessageDetails(id));
    };
}
// Temporarily use accountIdOverride to know which account to fetch data from.
// Update when responses include accountId
export function fetchChatMessageDetails(id, accountIdOverride) {
    return (dispatch, getState) => {
        const execution = getChatMessageDetails(getState(), id);
        const clientFactory = AibleClientFactory.getInstance();
        const accountIdPromise = accountIdOverride !== undefined
            ? Promise.resolve(accountIdOverride)
            : execution !== undefined
                ? Promise.resolve(execution.account_id)
                : clientFactory
                    .getContentGenerationClient()
                    .getExecutionById(Number(id))
                    .then((e) => e.account_id);
        return accountIdPromise
            .then((accountId) => clientFactory.getAccountClient().getCustomerClientFactory(accountId))
            .then((factory) => factory.getContentGenerationClient().getExecution(id))
            .then((response) => {
            dispatch(updateChatMessageDetails(response.id, response));
            const persisted = getChatMessageDetails(getState(), response.id);
            if (persisted === undefined) {
                throw Error("not persisted!");
            }
            return persisted;
        });
    };
}
// Temporarily use accountIdOverride to know which account to fetch data from.
// Update when responses include accountId
export function addOutputFeedbackItem(id, resultId, item) {
    return async (dispatch, getState) => {
        let execution = getChatMessageDetails(getState(), id);
        if (execution === undefined) {
            return Promise.resolve(undefined);
        }
        const factory = await AibleClientFactory.getInstance()
            .getAccountClient()
            .getCustomerClientFactory(execution.account_id);
        const userId = getUserID(getState());
        const userFeedback = execution.results
            .find((r) => r.id == resultId)
            ?.data?.output_feedback?.find((f) => f.user_id == userId) ?? {
            user_id: userId,
            feedback_items: []
        };
        // optimistic update
        dispatch(updateChatMessageDetails(id, {
            ...execution,
            results: execution.results.map((r) => r.id == resultId
                ? {
                    ...r,
                    data: {
                        ...r.data,
                        output_feedback: (r.data.output_feedback ?? [])
                            .filter((f) => f.user_id !== userId)
                            .concat({
                            ...userFeedback,
                            feedback_items: (userFeedback?.feedback_items ?? [])
                                .filter((i) => i.start_index != item.start_index && i.end_index != item.end_index)
                                .concat(item)
                        })
                    }
                }
                : r)
        }));
        const netUserScore = userFeedback.feedback_items.map((item) => item.score).reduce((x, y) => x + y, 0);
        const ratingPromise = netUserScore > 0
            ? dispatch(likeRatable("CONTENT_GENERATION_RESULT", resultId))
            : netUserScore < 0
                ? dispatch(dislikeRatable("CONTENT_GENERATION_RESULT", resultId))
                : Promise.resolve();
        return ratingPromise
            .then(() => factory.getContentGenerationClient().addOutputFeedbackItem(resultId, item))
            .then((response) => {
            execution = getChatMessageDetails(getState(), id);
            if (execution === undefined) {
                throw Promise.resolve(undefined);
            }
            dispatch(updateChatMessageDetails(id, {
                ...execution,
                results: execution.results.map((r) => (r.id == response.id ? response : r))
            }));
            return getChatMessageDetails(getState(), id);
        })
            .finally(() => {
            if (item?.score > 0 || item?.score < 0) {
                const nextId = nextReducer.getCurrentNextId(getState());
                return dispatch(nextReducer.checkAutomaticFineTuningThreshold(nextId));
            }
            return Promise.resolve();
        });
    };
}
